<template>
    <settings-control label="Font Weight">
        <dropdown
            theme="minimalistic"
            placeholder="Select Weight"
            :options="options"
            :value="fontWeight"
            native
            @input="onInput"
        />
    </settings-control>
</template>

<script>
import SettingsControl from '@/components/settings/shared/settings-control';
import { tailwindConfig } from '@/data/tailwind';

const configValues = tailwindConfig.theme.fontWeight;

export default {
    name: 'settings-control-font-weight',
    components: { SettingsControl },

    props: {
        value: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            fontWeight: this.value,
        };
    },

    computed: {
        options() {
            const defaultOption = { text: 'Default', value: '' };
            const weightOptions = Object.keys(configValues).map(key => ({ text: configValues[key], value: configValues[key] }));

            return [defaultOption].concat(weightOptions);
        },
    },

    watch: {
        value(newVal) {
            this.fontWeight = newVal;
        },
    },

    methods: {
        onInput(value) {
            this.fontWeight = value;

            this.$emit('input', {
                tailwindDefinitionProp: 'fontWeight',
                value,
            });
        },
    },
};
</script>
